import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SocialProofBar() {
  return <FadeIn data-id="element-342">
      <div className="w-full bg-gray-900 border-y border-gray-800 py-6" data-id="element-343">
        <div className="max-w-5xl mx-auto px-4 flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-center font-medium" data-id="element-344">
          <div className="text-lg text-gray-300" data-id="element-345">+300 nutricionistas</div>
          <div className="hidden sm:block text-gray-600" data-id="element-346">•</div>
          <div className="text-lg text-gray-300" data-id="element-347">6 Tomos</div>
          <div className="hidden sm:block text-gray-600" data-id="element-348">•</div>
          <div className="text-lg text-gray-300" data-id="element-349">6 Bonos</div>
          <div className="hidden sm:block text-gray-600" data-id="element-350">•</div>
          <div className="flex items-center gap-1 text-lg text-gray-300" data-id="element-351">
            4,9/5
            <div className="flex text-yellow-400 ml-1" data-id="element-352">
              <Star size={18} fill="currentColor" data-id="element-353" />
            </div>
          </div>
        </div>
      </div>
    </FadeIn>;
}